import template from './locationSelector.html';
import controller from './locationSelector.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    position: '<',
    staffUser: '<',
    program: '<',
    clientsId: '<',
    eventType: '<',
    selectedSearchVenue: '='
  }
};

export default component;
